import React from 'react';
import {
    Collapse, Card, CardBody, CardHeader, Col, Row, Table, Badge, Button, Form, FormGroup, Input, Label,
    Modal, ModalBody, ModalFooter, ModalHeader
} from 'reactstrap';
import Page from '../components/Page';

import { MdFilterList, MdKeyboardArrowUp, MdKeyboardArrowDown, MdDeleteForever, MdKeyboardArrowLeft, MdKeyboardArrowRight } from 'react-icons/md';
import { FiExternalLink } from 'react-icons/fi';
import * as Server from '../Server';
import NotificationSystem from 'react-notification-system';
import { NOTIFICATION_SYSTEM_STYLE } from '../utils/constants';
import * as GeneralFunctions from '../GeneralFunctions';
import PageSpinner from '../components/PageSpinner';
import Moment from 'react-moment';

let selectedRewardId = null;

class Rewards extends React.Component {

    constructor(props) {
        super(props);
        this.state = {
            showLoader: false,
            collapseFilter: false,
            removeRewardConfirmationModal: false,
            rewardDetailModal: false,
            rewardStatusId: null,
            rewards: [],
            filter: {
                title: "",
                state: "",
                zipCode: "",
                miles: "",
                status: "",
            },
            page: 1,
            limit: 10,
            totalRewards: 0,
            pages: 0,
            pageNumbers: [],
            rewardDetail: {}
        };
    }

    componentDidMount() {
        let permissions = GeneralFunctions.getUserPermission();
        if (!permissions.includes('rewards')) this.props.history.push('/dashboard');
        this.getRewardsDetails();
    }

    getRewardsDetails = async () => {
        try {
            this.setState({ showLoader: true });
            let filter = this.state.filter;
            let page = this.state.page;
            let limit = this.state.limit;
            let response = await Server.request({
                url: 'admin/reward/search',
                method: 'POST',
                data: { filter, page, limit }
            });
            this.setState({ showLoader: false });
            this.setState({ rewards: response.rewards, totalRewards: response.totalRewards, pages: response.pages });
            let pageNumbers = [];
            for (let page = 1; page <= response.pages; page++) {
                pageNumbers.push(page);
            }
            this.setState({ pageNumbers: pageNumbers });
        } catch (error) {
            this.setState({ showLoader: false });
            this.notificationSystem.addNotification({
                message: error.message,
                level: 'error',
            });
        }
    }

    removeReward = async (id) => {
        try {
            this.setState({ showLoader: true });
            let response = await Server.request({
                url: 'admin/reward/' + id + '/removeReward',
                method: 'DELETE'
            });
            if (response) {
                this.setState({ showLoader: false });
                selectedRewardId = null;
                this.notificationSystem.addNotification({
                    message: 'Reward removed successfully.',
                    level: 'success',
                });
                this.getRewardsDetails();
            }
        } catch (error) {
            this.setState({ showLoader: false });
            this.notificationSystem.addNotification({
                message: error.message,
                level: 'error',
            });
        }
    }

    toggleRemoveRewardConfirmationModal = async (id) => {
        if (!selectedRewardId && id) {
            selectedRewardId = id;
        }
        this.setState({
            removeRewardConfirmationModal: !this.state.removeRewardConfirmationModal
        });
    }

    setRewardId = async (_id) => {
        this.setState({ rewardStatusId: _id });
    }

    changeStatus = async (rewardId, value) => {
        try {
            this.setState({ showLoader: true });
            let status = value;
            let response = await Server.request({
                url: 'admin/reward/updateStatus',
                method: 'POST',
                data: { rewardId, status }
            });
            if (response) {
                this.setState({ showLoader: false });
                this.notificationSystem.addNotification({
                    message: 'Reward status updated successfully.',
                    level: 'success',
                });
                this.setState({ rewardStatusId: null });
                this.getRewardsDetails();
            }
        } catch (error) {
            this.setState({ showLoader: false });
            this.notificationSystem.addNotification({
                message: error.message,
                level: 'error',
            });
        }
    }

    search() {
        this.setState({ page: parseInt(1, 10) }, () => {
            this.getRewardsDetails();
        });
    }

    refreshPagination = async (page, limit) => {
        this.setState({ page: parseInt(page, 10), limit: limit }, () => {
            this.getRewardsDetails();
        });
    }

    getRewardInfo = async (id) => {
        try {
            this.setState({ showLoader: true });
            let response = await Server.request({
                url: 'admin/reward/details/' + id,
                method: 'GET'
            });
            if (response) {
                this.setState({ showLoader: false });
                this.setState({ rewardDetail: response.reward });
                this.setState({ rewardDetailModal: true });
            }
        } catch (error) {
            this.setState({ showLoader: false });
            this.notificationSystem.addNotification({
                message: error.message,
                level: 'error',
            });
        }
    }

    closeModal = async () => {
        this.setState({ rewardDetailModal: false })
    }


    render() {
        return (
            <div>
                <PageSpinner showLoader={this.state.showLoader} />
                <Page
                    title="Rewards"
                    breadcrumbs={[{ name: 'Rewards', active: true }]}
                >
                    <Row>
                        <Col xl={12} lg={12} md={12}>
                            <Card>
                                <CardHeader onClick={(event) => { this.setState({ collapseFilter: !this.state.collapseFilter }) }} style={{ cursor: 'pointer' }}>
                                    <React.Fragment>
                                        <MdFilterList style={{ fontSize: 20, marginRight: 10 }}></MdFilterList>
                                        Filter
                                        {
                                            this.state.collapseFilter ?
                                                <MdKeyboardArrowUp style={{ fontSize: 14, float: 'right' }}></MdKeyboardArrowUp>
                                                : <MdKeyboardArrowDown style={{ fontSize: 14, float: 'right' }}></MdKeyboardArrowDown>
                                        }
                                    </React.Fragment>
                                </CardHeader>
                                <Collapse isOpen={this.state.collapseFilter}>
                                    <CardBody>
                                        <Form onSubmit={(event) => { event.preventDefault(); this.search() }}>
                                            <Row>
                                                <Col xl={6} lg={12} md={12}>
                                                    <FormGroup row>
                                                        <Label for="title" sm={2}>
                                                            Title
                                                </Label>
                                                        <Col sm={10}>
                                                            <Input
                                                                type="text"
                                                                name="title"
                                                                placeholder="Title"
                                                                onChange={(event) => {
                                                                    event.persist();
                                                                    this.setState(prevState => ({
                                                                        filter: {
                                                                            ...prevState.filter,
                                                                            title: event.target.value
                                                                        }
                                                                    }));
                                                                }}
                                                            />
                                                        </Col>
                                                    </FormGroup>
                                                </Col>
                                                <Col xl={6} lg={12} md={12}>
                                                    <FormGroup row>
                                                        <Label for="state" sm={2}>
                                                            State
                                                </Label>
                                                        <Col sm={10}>
                                                            <Input
                                                                type="text"
                                                                name="state"
                                                                placeholder="State"
                                                                onChange={(event) => {
                                                                    event.persist();
                                                                    this.setState(prevState => ({
                                                                        filter: {
                                                                            ...prevState.filter,
                                                                            state: event.target.value
                                                                        }
                                                                    }));
                                                                }}
                                                            />
                                                        </Col>
                                                    </FormGroup>
                                                </Col>
                                            </Row>
                                            <Row>
                                                <Col xl={6} lg={12} md={12}>
                                                    <FormGroup row>
                                                        <Label for="zipCode" sm={2}>
                                                            Zip code
                                                </Label>
                                                        <Col sm={10}>
                                                            <Input
                                                                type="text"
                                                                name="zipCode"
                                                                placeholder="Zip code"
                                                                onChange={(event) => {
                                                                    event.persist();
                                                                    this.setState(prevState => ({
                                                                        filter: {
                                                                            ...prevState.filter,
                                                                            zipCode: event.target.value
                                                                        }
                                                                    }));
                                                                }}
                                                            />
                                                        </Col>
                                                    </FormGroup>
                                                </Col>
                                                <Col xl={6} lg={12} md={12}>
                                                    <FormGroup row>
                                                        <Label for="miles" sm={2}>
                                                            Miles
                                                </Label>
                                                        <Col sm={10}>
                                                            <Input
                                                                type="text"
                                                                name="miles"
                                                                placeholder="Miles"
                                                                onChange={(event) => {
                                                                    event.persist();
                                                                    this.setState(prevState => ({
                                                                        filter: {
                                                                            ...prevState.filter,
                                                                            miles: event.target.value
                                                                        }
                                                                    }));
                                                                }}
                                                            />
                                                        </Col>
                                                    </FormGroup>
                                                </Col>
                                            </Row>
                                            <Row>
                                                <Col xl={6} lg={12} md={12}>
                                                    <FormGroup row>
                                                        <Label for="status" sm={2}>
                                                            Status
                                                </Label>
                                                        <Col sm={10}>
                                                            <Input type="select" name="status" onChange={(event) => {
                                                                event.persist();
                                                                this.setState(prevState => ({
                                                                    filter: {
                                                                        ...prevState.filter,
                                                                        status: event.target.value
                                                                    }
                                                                }));
                                                            }}>
                                                                <option value="">Select</option>
                                                                <option value="pending">Pending</option>
                                                                <option value="approved">Approved</option>
                                                                <option value="rejected">Rejected</option>
                                                            </Input>
                                                        </Col>
                                                    </FormGroup>
                                                </Col>

                                                <FormGroup className="d-flex justify-content-center w-100">
                                                    <Button style={{ "width": "30%" }} type="submit">Search</Button>
                                                </FormGroup>
                                            </Row>
                                        </Form>
                                    </CardBody>
                                </Collapse>
                            </Card>
                        </Col>
                    </Row>
                    <Row>
                        <Col>
                            <Card className="mb-3">
                                <CardHeader>
                                    <Row>
                                        <Col xl={4} lg={12} md={12}>
                                            <div className="d-flex">
                                                <div sm={4} className="mt-2 pr-2"><Label>Shown</Label></div>
                                                <div sm={4}>
                                                    <Input type="select" name="pageLimit" onChange={(event) => { this.refreshPagination(1, event.target.value) }}>
                                                        <option value={10}>10</option>
                                                        <option value={50}>50</option>
                                                        <option value={100}>100</option>
                                                    </Input>
                                                </div>
                                                <div sm={4} className="mt-2 pl-2"><Label>entries</Label></div>
                                            </div>
                                        </Col>
                                        <Col xl={4} lg={12} md={12}>
                                            <div className="d-flex justify-content-center">
                                                <div className="mt-2 pr-2">
                                                    <Label>Showing {!this.state.totalRewards ? 0 : ((this.state.page * this.state.limit) - (this.state.limit - 1))}  to {(this.state.page * this.state.limit) > this.state.totalRewards ? this.state.totalRewards : (this.state.page * this.state.limit)} of {this.state.totalRewards}
                                                    </Label>
                                                </div>
                                            </div>
                                        </Col>
                                        <Col xl={4} lg={12} md={12}>
                                            <div className="d-flex justify-content-end">
                                                <div sm={4} className="pr-2"><Button className="rounded-circle" disabled={this.state.page <= 1} onClick={(event) => this.refreshPagination(this.state.page - 1, this.state.limit)}><MdKeyboardArrowLeft size="20px"></MdKeyboardArrowLeft></Button></div>
                                                <div sm={4}>
                                                    <Input type="select" value={this.state.page} name="filter" onChange={(event) => { this.refreshPagination(event.target.value, this.state.limit) }}>
                                                        {
                                                            this.state.pageNumbers.map((pageNumber, index) => (
                                                                <option value={pageNumber} key={index}>{pageNumber}</option>
                                                            ))
                                                        }
                                                    </Input>
                                                </div>
                                                <div sm={4} className="pl-2"><Button className="rounded-circle" disabled={this.state.page >= this.state.pages} onClick={(event) => this.refreshPagination(this.state.page + 1, this.state.limit)}><MdKeyboardArrowRight size="20px"></MdKeyboardArrowRight></Button></div>
                                            </div>
                                        </Col>
                                    </Row>
                                </CardHeader>
                                <CardBody>
                                    <Table striped hover responsive>
                                        <thead>
                                            <tr>
                                                <th>Title</th>
                                                <th>State</th>
                                                <th>Zip code</th>
                                                <th>Miles</th>
                                                <th>Posted By</th>
                                                <th>Date</th>
                                                <th>Status</th>
                                                <th>Actions</th>
                                                <th></th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            {
                                                this.state.rewards && this.state.rewards.length > 0
                                                    ? this.state.rewards.map((reward, index) => (
                                                        <tr key={index}>
                                                            <td><Button color="link" style={{ textAlign: 'left' }} onClick={(event) => this.getRewardInfo(reward._id)}>{reward.title}</Button></td>
                                                            <td>{reward.state || ''}</td>
                                                            <td>{reward.zipCode || ''}</td>
                                                            <td>{reward.miles}</td>
                                                            <td>{reward.owner.firstName} {reward.owner.middleName || ''} {reward.owner.lastName || ''}</td>
                                                            <td>{<Moment format="MM/DD/YYYY">{reward.createdAt}</Moment>}</td>
                                                            {
                                                                this.state.rewardStatusId === reward._id ?
                                                                    <td><Input type="select" name="status" value={reward.status} onChange={(event) => { this.changeStatus(reward._id, event.target.value) }} >
                                                                        <option value="">Select</option>
                                                                        <option value="approved">Approve</option>
                                                                        <option value="rejected">Reject</option>
                                                                    </Input>
                                                                    </td>
                                                                    : <td>
                                                                        {
                                                                            reward.status == 'pending' &&
                                                                            <Badge color="warning" pill>{GeneralFunctions.capitalize(reward.status)}</Badge>
                                                                        }
                                                                        {
                                                                            reward.status == 'approved' &&
                                                                            <Badge color="success" pill>{GeneralFunctions.capitalize(reward.status)}</Badge>
                                                                        }
                                                                        {
                                                                            reward.status == 'rejected' &&
                                                                            <Badge color="danger" pill>{GeneralFunctions.capitalize(reward.status)}</Badge>
                                                                        }
                                                                        <Button color="link" onClick={() => this.setRewardId(reward._id)}>Change</Button>
                                                                    </td>
                                                            }
                                                            <td><Button onClick={(event) => this.toggleRemoveRewardConfirmationModal(reward._id)}><MdDeleteForever size="20px"></MdDeleteForever></Button></td>
                                                            <td>
                                                                {
                                                                    process.env.REACT_APP_EOS_URL && reward.eosTransactionId &&
                                                                    <FiExternalLink style={{ fontSize: 20, marginRight: 5, cursor: 'pointer' }} onClick={() => window.open(process.env.REACT_APP_EOS_URL + reward.eosTransactionId, "_blank")}></FiExternalLink>
                                                                }
                                                            </td>
                                                        </tr>
                                                    )) :
                                                    <tr><td colSpan="9" className="text-center">No rewards found.</td></tr>
                                            }
                                        </tbody>
                                    </Table>
                                </CardBody>
                                {
                                    this.state.removeRewardConfirmationModal ?
                                        <Modal
                                            isOpen={this.state.removeRewardConfirmationModal}
                                            toggle={(event) => this.toggleRemoveRewardConfirmationModal()}
                                            className="modal-md">
                                            <ModalHeader toggle={(event) => this.toggleRemoveRewardConfirmationModal()}></ModalHeader>
                                            <ModalBody>
                                                Are you sure you want to delete this reward ?
                                        </ModalBody>
                                            <ModalFooter>
                                                <Button color="secondary" onClick={(event) => this.toggleRemoveRewardConfirmationModal()}>Cancel</Button>{' '}
                                                <Button color="primary" onClick={(event) => { this.toggleRemoveRewardConfirmationModal(); this.removeReward(selectedRewardId) }}>
                                                    Delete
                                            </Button>
                                            </ModalFooter>
                                        </Modal>
                                        : null
                                }
                                {
                                    this.state.rewardDetailModal ?
                                        <Modal
                                            isOpen={this.state.rewardDetailModal}
                                            toggle={(event) => this.closeModal()}
                                            className="modal-lg">
                                            <ModalHeader toggle={(event) => this.closeModal()}>Reward Details</ModalHeader>
                                            <ModalBody>
                                                <Row>
                                                    <Col lg={12} md={12} sm={12} xs={12}>
                                                        <Row>
                                                            <Label sm={3}>Title :</Label>
                                                            <Label sm={9}>{this.state.rewardDetail.title}</Label>
                                                        </Row>
                                                        <Row>
                                                            <Label sm={3}>Description :</Label>
                                                            <Label sm={9}>{this.state.rewardDetail.description || ''}</Label>
                                                        </Row>
                                                        <Row>
                                                            <Label sm={3}>Send To :</Label>
                                                            <Label sm={9}>
                                                                {this.state.rewardDetail.allPingers && !this.state.rewardDetail.allBasicUsers && 'All Pingers'}
                                                                {!this.state.rewardDetail.allPingers && this.state.rewardDetail.allBasicUsers && 'All Enthusiasts'}
                                                                {this.state.rewardDetail.allPingers && this.state.rewardDetail.allBasicUsers && 'All Pingers and All Enthusiasts'}
                                                            </Label>
                                                        </Row>
                                                        <Row>
                                                            <Label sm={3}>State :</Label>
                                                            <Label sm={9}>{this.state.rewardDetail.state || ''}</Label>
                                                        </Row>
                                                        <Row>
                                                            <Label sm={3}>Zip code :</Label>
                                                            <Label sm={9}>{this.state.rewardDetail.zipCode || ''}</Label>
                                                        </Row>
                                                        <Row>
                                                            <Label sm={3}>Miles :</Label>
                                                            <Label sm={9}>{this.state.rewardDetail.miles || ''}</Label>
                                                        </Row>
                                                        <Row>
                                                            <Label sm={3}>Posted By :</Label>
                                                            <Label sm={9}>{this.state.rewardDetail.owner.firstName} {this.state.rewardDetail.owner.middleName || ''} {this.state.rewardDetail.owner.lastName || ''}</Label>
                                                        </Row>
                                                        <Row>
                                                            <Label sm={3}>Date :</Label>
                                                            <Label sm={9}>{<Moment format="MM/DD/YYYY">{this.state.rewardDetail.createdAt}</Moment>}</Label>
                                                        </Row>
                                                        <Row>
                                                            <Label sm={3}>Status :</Label>
                                                            <Label sm={9}>
                                                                {
                                                                    this.state.rewardDetail.status == 'pending' &&
                                                                    <Badge color="warning" pill>{GeneralFunctions.capitalize(this.state.rewardDetail.status)}</Badge>
                                                                }
                                                                {
                                                                    this.state.rewardDetail.status == 'approved' &&
                                                                    <Badge color="success" pill>{GeneralFunctions.capitalize(this.state.rewardDetail.status)}</Badge>
                                                                }
                                                                {
                                                                    this.state.rewardDetail.status == 'rejected' &&
                                                                    <Badge color="danger" pill>{GeneralFunctions.capitalize(this.state.rewardDetail.status)}</Badge>
                                                                }
                                                            </Label>
                                                        </Row>
                                                    </Col>
                                                </Row>
                                            </ModalBody>
                                            <ModalFooter>
                                                <Button color="secondary" onClick={(event) => this.closeModal()}>Cancel</Button>
                                            </ModalFooter>
                                        </Modal>
                                        : null
                                }
                            </Card>
                        </Col>
                    </Row>
                    <NotificationSystem
                        dismissible={false}
                        ref={notificationSystem =>
                            (this.notificationSystem = notificationSystem)
                        }
                        style={NOTIFICATION_SYSTEM_STYLE}
                    />
                </Page>
            </div>
        );
    }
}
export default Rewards;
